export const visibleScreenHeightVarName = '--visible-screen-height'
export const visibleScreenHeightVar = `var(${visibleScreenHeightVarName})`
